// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"3248366d","356":"271f9a94","370":"e8483829","453":"f74dd907","531":"344319cd","660":"4801a704","914":"7f11acde"}[chunkId] + ".chunk.js";
};